import React from 'react';
import {Plus, Close} from "assets/icons";

const Chip = ({color, type, children, disabled, onClick, select,icon}) => {
    const CHIP_COLOR = {
        PRIMARY: 'bg-gray-100 ',
        WARNING: 'bg-yellow-100 text-yellow-800',
        ALERT: 'bg-red-100 text-red-800',
        INFO: 'bg-green-100 text-green-800',
    }
    const CHIP_TYPE = {
        SELECTOFF: 'rounded text-gray-800',
        SELECTON: 'rounded bg-gray-500 text-white',
        INDICATOR: 'rounded-[6px]'
    }
    // Status indicators use the temp worker app badge (styles/components/_badge.scss).
    const BADGE_COLOR = {
        PRIMARY: 'bg-gray-100 text-gray-700',
        WARNING: 'bg-yellow-50 text-yellow-700',
        ALERT: 'bg-red-50 text-red-700',
        INFO: 'bg-green-50 text-green-700',
    }
    const typeClassName = CHIP_TYPE[type || 'INDICATOR']
    const colorClassName = CHIP_COLOR[color || 'PRIMARY']

    if ((type || 'INDICATOR') === 'INDICATOR') {
        return (
            <span className={`badge ${BADGE_COLOR[color || 'PRIMARY']}`}>
                <span className="max-w-[128px] truncate">{children}</span>
            </span>
        );
    }

    return (
        <button
            className={'ft-sm h-6 w-auto px-1.5  flex items-center justify-center' +
                ' gap-1 ' + typeClassName + ' ' + colorClassName}
            disabled={disabled}
        onClick={onClick}>
     <span className=' max-w-[128px] px-1  truncate  overflow-hidden '>
         {children}

     </span>
            {icon?
                select ?
                    <span>
                    <Close wh={15} color={'#ffffff'}/>
                    </span>:
                    <span>
                    <Plus wh={15} className='fill-gray-400'/>
                    </span>

            :''}
        </button>
    );
};

export default Chip;